import {Inject, Injectable, DOCUMENT} from '@angular/core';

import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {PageService} from '../page/page.service';
import {environment} from '../../../environments/environment';
import {DeviceDetectorService} from 'ngx-device-detector';

@Injectable({
  providedIn: 'root'
})
export class FullscreenService {

  elem: any;

  constructor(
    @Inject(DOCUMENT) private document: any,
    private pageSrv: PageService,
    private deviceSrv: DeviceDetectorService
  ) {
  }

  initialize() {
    this.elem = document.documentElement;
  }

  open() {

    this.pageSrv.displayOnlyMain = true;

    // disabled is dev or mobile
    if (environment.envName === 'development' || !this.deviceSrv.isDesktop()) {
      return;
    }

    if (this.elem.requestFullscreen) {
      this.elem.requestFullscreen();
    } else if (this.elem.mozRequestFullScreen) {
      /* Firefox */
      this.elem.mozRequestFullScreen();
    } else if (this.elem.webkitRequestFullscreen) {
      /* Chrome, Safari and Opera */
      this.elem.webkitRequestFullscreen();
    } else if (this.elem.msRequestFullscreen) {
      /* IE/Edge */
      this.elem.msRequestFullscreen();
    }
  }

  close() {

    this.pageSrv.displayOnlyMain = false;

    // disabled is dev or mobile
    if (environment.envName === 'development' || !this.deviceSrv.isDesktop()) {
      return;
    }

    try {
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        /* Firefox */
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        /* IE/Edge */
        this.document.msExitFullscreen();
      }
    } catch (e) {
      console.log(e.toString());
    }
  }
}
